import { useContext } from "react";
import { IThirdPartyAdministrationContext, ThirdPartyAdministrationContext, ThirdPartyAdministrationProvider } from './provider'
import { IViewAndDownloadProps } from "hooks/useFile";

const useHandleViewFile = (): IThirdPartyAdministrationContext => {

    const { handleViewFile } = useContext(ThirdPartyAdministrationContext)

    return {
        handleViewFile
    }
}


export default useHandleViewFile